export default __webpack_public_path__ + "static/media/01.faca2230.jpg";